import { render } from "./rate.vue?vue&type=template&id=784b363b&scoped=true"
import script from "./rate.vue?vue&type=script&lang=js"
export * from "./rate.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-784b363b"

export default script